export default "__VITE_ASSET__C$VVQ390__"